var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 54.8231V16.1331C0 15.6951 0.0729511 15.184 0.292048 14.746C0.511146 14.3081 0.73 13.9431 1.09499 13.5781L14.235 0.949098C14.527 0.657049 14.965 0.365 15.33 0.219097C15.7679 0.0731947 16.2059 0 16.6441 0H41.9751C46.2822 0 49.7131 3.43088 49.7131 7.738V31.463C49.2022 31.2444 48.5452 31.2444 47.8881 31.2444C47.304 31.2444 46.7202 31.2444 46.136 31.3173V7.66533C46.136 5.40239 44.3111 3.57739 42.0481 3.57739L17.8121 3.57715V9.49009C17.8121 13.7242 14.308 17.2281 10.0741 17.2281H3.57711V54.7501C3.57711 57.013 5.40211 58.838 7.66505 58.838H33.653C34.6751 60.2251 35.843 61.466 37.1572 62.488L7.73817 62.4883C3.43111 62.5612 0 59.057 0 54.8231ZM61.466 48.764C61.466 56.283 55.4069 62.342 47.888 62.342C40.369 62.342 34.31 56.21 34.31 48.764C34.31 41.318 40.3691 35.186 47.888 35.186C55.407 35.186 61.466 41.2449 61.466 48.764ZM55.115 46.7931L47.888 39.5661L40.661 46.7931L43.216 49.3481L45.9901 46.574V57.232H49.6401V46.501L52.4142 49.2751L55.115 46.7931Z",
    fill: "#003D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/Document Upload.d51c4f18896c0e7d9ecc89841620cd36.svg";
export { ForwardRef as ReactComponent };